// extracted by mini-css-extract-plugin
export default {"containprod":"iN","containprod2":"jN","title":"kN","servings":"lN","recommendation":"mN","image":"nN","flavorswrap":"oN","flavorsgroupwrap":"pN","moredetailsWrap":"qN","infoWrap":"rN","price":"sN","regularPrice":"tN","netPrice":"uN","addtocartcontainer":"vN","error":"wN"};
    if(module.hot) {
      // 1730991508924
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  